"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);



var _subscriptionRedirect = require('web/services/subscriptionRedirect');
var _gotoURL = require('web/services/gotoURL');
var _upgrade = require('shared/enum/upgrade');

var _freeCapAnalytics = require('web/services/freeCapAnalytics');














 const useCheckout = ({
  orgKey: OrgKey,
  hasSubscription,
  onEarlyCheckout,
  analyticsContext,
}) => _react.useCallback.call(void 0, 
  async (items, { action = _upgrade.CheckoutActionType.UPGRADE } = {}) => {
    const Items = items
    const SuccessURL = _subscriptionRedirect.buildSubscriptionSuccessURL.call(void 0, OrgKey, items.map(i => i.Type), action, {
      source: _optionalChain([analyticsContext, 'optionalAccess', _ => _.source]),
    })
    const CancelURL = _subscriptionRedirect.getCurrentURL.call(void 0, )
    const teamItem = items.find(i => i.Type === _upgrade.SubscriptionItemType.TEAM)

    if (teamItem) {
      _freeCapAnalytics.trackFreeCapLockedChatCheckoutStarted.call(void 0, analyticsContext, {
        checkout_action: action,
        checkout_units: teamItem.Units,
        has_subscription: hasSubscription,
      })
    }

    const redirectURL = hasSubscription
      ? await _actions2.default.checkout({ OrgKey, Items })
        .then(onEarlyCheckout)
        .then(() => SuccessURL)
      : await _actions2.default.getCheckoutURL({ OrgKey, Items, SuccessURL, CancelURL })
        .then(r => r.URL)

    _gotoURL.gotoURL.call(void 0, redirectURL)
  },
  [OrgKey, analyticsContext, hasSubscription, onEarlyCheckout],
); exports.useCheckout = useCheckout
